import { CSSObject } from "@emotion/react";
import { constants } from "@newsela/angelou";

import { greyDarkWithOpacity } from "@/angelouCE/utils/constants";

const { colors } = constants;

const greyDark = colors.ui.neutral[600];
const greyExtraLight = colors.ui.neutral[25];

export const rootCss = {
  listStyleType: "none",
  margin: "8px 0",
};

export const buttonCss: CSSObject = {
  alignItems: "center",
  backgroundColor: greyExtraLight,
  borderRadius: "4px",
  color: greyDark,
  display: "flex",
  padding: "8px 8px 8px 16px",
  width: "100%",
  font: "inherit",
  gap: 0,
  justifyContent: "space-between",

  "&": {
    opacity: 1,
  },

  "&:hover, &:focus": {
    backgroundColor: greyDarkWithOpacity,
  },
};

export const buttonDetailsCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "4px",
  textAlign: "left",
};

export const iconCss: CSSObject = {
  path: {
    stroke: greyDark,
  },
};
